module.exports = __webpack_public_path__ + "img/icons B_19.083ff582.svg";